import { render, staticRenderFns } from "./linkWrapper.vue?vue&type=template&id=66a36c3b&"
import script from "./linkWrapper.vue?vue&type=script&lang=js&"
export * from "./linkWrapper.vue?vue&type=script&lang=js&"
import style0 from "./linkWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports